const UI = Object.freeze({
  navigation: {
    icon: {
      'default': '/assets/icon.png',
      dark: '/assets/network_logo_dark.webp',
    },
  },
});

export default UI;
